import { anonymousClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/client';

export const authClient = createAuthClient({
  baseURL: window.location.origin,
  basePath: '/api/auth',
  plugins: [anonymousClient()],
});

/** Returning players (Discord or a guest cookie) skip the welcome card. */
export async function hasSession(): Promise<boolean> {
  const { data } = await authClient.getSession();
  return data !== null;
}

export async function startGuest(): Promise<void> {
  const result = await authClient.signIn.anonymous();
  if (result.error)
    throw new Error(result.error.message ?? 'Could not start a guest session');
}

/** `name` becomes the player's name if this creates their account; a returning player keeps theirs. A refused name comes back as `?error_description=`. */
export const signInWithDiscord = (name: string) =>
  authClient.signIn.social({
    provider: 'discord',
    callbackURL: window.location.origin,
    errorCallbackURL: window.location.origin,
    additionalData: { name },
  });

export async function signOut(): Promise<void> {
  await authClient.signOut();
}

export async function deleteAccount(): Promise<void> {
  const result = await authClient.deleteUser();
  if (result.error)
    throw new Error(result.error.message ?? 'Could not delete the account');
}
